"use client";

import { c as _c } from "react/compiler-runtime";
import { Media } from "@opensea/ui-kit";
import { TopNavbarContainer } from "./TopNavbarContainer";
export function DesktopNavbarContainer(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Media greaterThanOrEqual="lg"><TopNavbarContainer>{children}</TopNavbarContainer></Media>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}